import React, { useEffect, useMemo, useRef, useState } from "react";
import { io } from "socket.io-client";
import DeviceLayout from "./DeviceLayout";
import "../css/Layout.css";

const MAX_MESSAGES = 500;

const DeviceConsole = () => {
  const [connected, setConnected] = useState(false);
  const [messages, setMessages] = useState([]);
  const logRef = useRef(null);

  const deviceId = useMemo(() => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("id");
  }, []);

  useEffect(() => {
    if (!deviceId) {
      return;
    }

const socket = io("https://api.cloud.linkbms.eu", {
  path: "/socket.io",
  withCredentials: true,
  transports: ["websocket", "polling"],
});

    const handleConnect = () => setConnected(true);
    const handleDisconnect = () => setConnected(false);

    const handleConsoleMessage = (payload) => {
      if (!payload || payload.device_id !== deviceId) {
        return;
      }

      const messageBody =
        typeof payload.message === "string"
          ? payload.message
          : JSON.stringify(payload.message);

      const entry = {
        topic: payload.topic || "",
        text: messageBody,
        receivedAt: payload.received_at || new Date().toISOString(),
      };

      setMessages((prev) => {
        const next = [...prev, entry];
        if (next.length > MAX_MESSAGES) {
          return next.slice(next.length - MAX_MESSAGES);
        }
        return next;
      });
    };

    socket.on("connect", handleConnect);
    socket.on("disconnect", handleDisconnect);
    socket.on("mqtt_console", handleConsoleMessage);

    return () => {
      socket.off("connect", handleConnect);
      socket.off("disconnect", handleDisconnect);
      socket.off("mqtt_console", handleConsoleMessage);
      socket.disconnect();
    };
  }, [deviceId]);

  useEffect(() => {
    if (logRef.current) {
      logRef.current.scrollTop = logRef.current.scrollHeight;
    }
  }, [messages]);

  return (
    <DeviceLayout>
      <div className="console-toolbar">
        <div className="console-status">
          <span
            className={`console-status-dot ${connected ? "connected" : ""}`}
          ></span>
          <span>{connected ? "Live stream connected" : "Disconnected"}</span>
          <span>Device: {deviceId || "N/A"}</span>
        </div>
        <button onClick={() => setMessages([])}>Clear</button>
      </div>

      <div className="console-log" ref={logRef}>
        {messages.length === 0 ? (
          <div className="console-empty">
            Waiting for console messages from this device...
          </div>
        ) : (
          messages.map((item, index) => (
            <div className="console-line" key={`${item.receivedAt}-${index}`}>
              [{new Date(item.receivedAt).toLocaleString()}] {item.topic}: {item.text}
            </div>
          ))
        )}
      </div>
    </DeviceLayout>
  );
};

export default DeviceConsole;
